import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { message, Button, Card, Form, Checkbox, DatePicker, Spin, InputNumber } from 'antd';
import { Action, Field, GET, POSTFormData, QueryDetail, QueryParam, errorCatch, makeFormData, useUserContext } from 'fennec-ui';

import locale from 'antd/es/date-picker/locale/ru_RU';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import PageLayout from '../../components/PageLayout';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import EmojiTextArea from '../../../common/EmojiTextArea';
import Icofont from 'react-icofont';
import YImage from '../../../common/YImage';
import { isAnyFederationAdministrator } from '../../../common/Tool';

dayjs.locale('ru');
var _ = require('lodash');

function ReportRatingVKForm(props) {
    const { auth, form, submit } = props;

    const [header, setHeader] = useState()

    useEffect(() => {
        GET(auth, `/api/config/bykey?key=ratingvkheader`,
            ({ data }) => {
                setHeader(data?.value);
                form.setFieldValue("header", data?.value)
            },
            errorCatch
        );

    }, [])

    return (
        <Form
            form={form}
            onFinish={submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                header: header,
                saveHeader: false,
                r52Man: 20,
                r52Woman: 20,
                rSezonMan: 20,
                rSezonWoman: 20,
                rOtnositMan: 20,
                rOtnositWoman: 20,
            }}
        >
            <div>
                <Form.Item label="Шапка"
                    name="header"
                    rules={[{ required: false, message: 'Пожалуйста, укажите текст шапки!' }]}
                >
                    <EmojiTextArea rows={8} />
                </Form.Item>
                <Form.Item name="saveHeader" valuePropName="checked">
                    <Checkbox>
                        Сохранить новую шапку
                    </Checkbox>
                </Form.Item>

                {/* <Form.Item
                    label={"Дата абсолютного рейтинга"}
                    name={"daterating"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите дату!' }]}
                >
                    <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                </Form.Item> */}

                <Form.Item
                    label={"Мероприятие"}
                    name={"meropriyatie"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите мероприятие!' }]}
                >
                    <Field
                        key={"meropriyatie"}
                        auth={auth}
                        formItem={true}
                        item={{
                            type: "object",
                            label: "Мероприятие",
                            name: "meropriyatie",
                            mode: "dialog",
                            queryFilter: [
                                QueryDetail("collection"),
                                // QueryOrder("nachaloSorevnovaniya", "ASC"),
                                // QueryOrder("nazvanieMeropriyatiya", "ASC")
                            ],
                            dropdownActions: undefined,
                            relation: {
                                uiFilter: () => [
                                    {
                                        name: "nazvanieMeropriyatiya",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "mestoProvedeniya",
                                        sort: true,
                                        filter: true,
                                    },
                                    {
                                        name: "nachaloSorevnovaniya",
                                        type: "date",
                                        queryRaw: (filterByKey, item, akey) => {
                                            return QueryParam("w-lge-" + akey, filterByKey.format("YYYY-MM-DD"))
                                        },
                                        sort: true,
                                        filter: true,
                                        sorted: "ASC",
                                        filtered: dayjs(dayjs().year() + "-01-01"),
                                    },
                                ],
                                displayString: (item) => {
                                    return dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " +
                                        item?.nazvanieMeropriyatiya + ", " +
                                        _.get(item, "mestoProvedeniya.name")
                                },
                                display: (item) => {
                                    return (
                                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                            <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                <YImage item={item} width={32} hidePreview={true} />
                                            </div>

                                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                    <span style={{ fontWeight: "600" }}>
                                                        {item.nazvanieMeropriyatiya}
                                                    </span>
                                                </div>
                                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                    <span style={{
                                                        marginRight: "5px",
                                                        borderRadius: "5px",
                                                        backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                        color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                        fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",
                                                        fontSize: "12px",
                                                        boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                        padding: "2px 4px"
                                                    }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                    <span>{item?.mestoProvedeniya?.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                },
                                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                type: "many-one",
                            },
                        }}
                    />
                </Form.Item>

                <div style={{ display: "flex", justifyContent: "space-between", padding: "2px 0" }}>
                    <div style={{ flex: 1, maxWidth: "210px" }}>Рейтинг "52 недели"</div>
                    <div style={{ display: "flex" }}>
                        <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"r52Man"}>
                            <InputNumber prefix={
                                <Icofont icon="businessman" style={{ color: "blue" }} />
                            } min={1} variant='outlined' size="small" />
                        </Form.Item>
                        <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"r52Woman"}>
                            <InputNumber prefix={
                                <Icofont icon="businesswoman" style={{ color: "red" }} />
                            } min={1} variant='outlined' size="small" />
                        </Form.Item>
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", padding: "2px 0" }}>
                    <div style={{ flex: 1, maxWidth: "210px" }}>Рейтинг "Сезонный"</div>
                    <div style={{ display: "flex" }}>
                        <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"rSezonMan"}>
                            <InputNumber prefix={
                                <Icofont icon="businessman" style={{ color: "blue" }} />
                            } min={1} variant='outlined' size="small" />
                        </Form.Item>
                        <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"rSezonWoman"}>
                            <InputNumber prefix={
                                <Icofont icon="businesswoman" style={{ color: "red" }} />
                            } min={1} variant='outlined' size="small" />
                        </Form.Item>
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", padding: "2px 0" }}>
                    <div style={{ flex: 1, maxWidth: "210px" }}>Рейтинг "Отностельный"</div>
                    <div style={{ display: "flex" }}>
                        <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"rOtnositMan"}>
                            <InputNumber prefix={
                                <Icofont icon="businessman" style={{ color: "blue" }} />
                            } min={1} variant='outlined' size="small" />
                        </Form.Item>
                        <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"rOtnositWoman"}>
                            <InputNumber prefix={
                                <Icofont icon="businesswoman" style={{ color: "red" }} />
                            } min={1} variant='outlined' size="small" />
                        </Form.Item>
                    </div>
                </div>
            </div>

        </Form>
    )
}

export default function ReportsCommon(props) {
    const { auth } = props;
    const user = useUserContext();

    return (
        <PageLayout>
            <Action
                readonly={false}
                auth={auth}
                action={(values, unlock, close) => {
                    close();
                }}
                modal={{
                    title: "Изменение тарифов для VK",
                    width: "700px"
                }}
                // okText="Построить отчет"
                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button type="link" onClick={click}>Изменение тарифов для VK</Button>
                    </div>
                )}
                steps={[
                    {
                        key: "request",
                        name: "Шаг 1",
                        form: (props) => {
                            const { auth, form, submit } = props;
                            return (
                                <Form
                                    form={form}
                                    onFinish={submit}
                                    labelAlign={"left"}
                                    layout={"vertical"}
                                    initialValues={{
                                        short: false
                                    }}
                                >
                                    <Form.Item
                                        label={"Дата начала"}
                                        name={"datestart"}
                                        rules={[{ required: true, message: 'Пожалуйста, укажите дату начала!' }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                                    </Form.Item>

                                    <Form.Item
                                        label={"Дата окончания"}
                                        name={"dateend"}
                                        rules={[{ required: true, message: 'Пожалуйста, укажите дату окончания!' }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                                    </Form.Item>

                                    <Form.Item name="short" valuePropName="checked">
                                        <Checkbox>
                                            Не выводить услуги
                                        </Checkbox>
                                    </Form.Item>
                                </Form>
                            )
                        },
                        action: (values, unlock, close) => {
                            var datestart = dayjs(values.datestart).format("YYYY-MM-DD")
                            var dateend = dayjs(values.dateend).format("YYYY-MM-DD")

                            GET(auth, `/api/report/vkforfedadminbyperiod?datestart=${datestart}&dateend=${dateend}&short=${!!values.short}`,
                                ({ data }) => {
                                    close({ text: data });
                                },
                                (err) => errorCatch(err, () => unlock())
                            );
                        },
                    },
                    {
                        key: "view",
                        name: "Шаг 2",
                        noAntForm: true,
                        okText: "Закрыть",
                        form: (props) => {
                            let text = props?.data?.request?.text || ""
                            console.log(props?.data);
                            return (
                                <div>
                                    <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                                        <CopyToClipboard text={text}
                                            onCopy={() => message.success("Скопировано")}>
                                            <Button>Скопировать</Button>
                                        </CopyToClipboard>
                                    </div>

                                    <div style={{ maxHeight: "600px", overflow: "auto" }}>
                                        <pre>
                                            {text}
                                        </pre>
                                    </div>
                                </div>
                            )
                        },
                    }
                ]}
            />
            <Action
                readonly={false}
                auth={auth}
                action={(values, unlock, close) => {
                    close();
                }}
                modal={{
                    title: "Изменение тарифов для VK (v2))",
                    width: "700px"
                }}
                // okText="Построить отчет"
                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button type="link" onClick={click}>Изменение тарифов для VK (v2)</Button>
                    </div>
                )}
                steps={[
                    {
                        key: "request",
                        name: "Шаг 1",
                        form: (props) => {
                            const { auth, form, submit } = props;
                            return (
                                <Form
                                    form={form}
                                    onFinish={submit}
                                    labelAlign={"left"}
                                    layout={"vertical"}
                                    initialValues={{
                                        short: false
                                    }}
                                >
                                    <Form.Item
                                        label={"Дата начала"}
                                        name={"datestart"}
                                        rules={[{ required: true, message: 'Пожалуйста, укажите дату начала!' }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                                    </Form.Item>

                                    <Form.Item
                                        label={"Дата окончания"}
                                        name={"dateend"}
                                        rules={[{ required: true, message: 'Пожалуйста, укажите дату окончания!' }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                                    </Form.Item>

                                    <Form.Item name="short" valuePropName="checked">
                                        <Checkbox>
                                            Не выводить услуги
                                        </Checkbox>
                                    </Form.Item>
                                </Form>
                            )
                        },
                        action: (values, unlock, close) => {
                            var datestart = dayjs(values.datestart).format("YYYY-MM-DD")
                            var dateend = dayjs(values.dateend).format("YYYY-MM-DD")

                            GET(auth, `/api/report/vkforfedadminbyperiod-v2?datestart=${datestart}&dateend=${dateend}&short=${!!values.short}`,
                                ({ data }) => {
                                    close({ text: data });
                                },
                                (err) => errorCatch(err, () => unlock())
                            );
                        },
                    },
                    {
                        key: "view",
                        name: "Шаг 2",
                        noAntForm: true,
                        okText: "Закрыть",
                        form: (props) => {
                            let text = props?.data?.request?.text || ""
                            console.log(props?.data);
                            return (
                                <div>
                                    <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                                        <CopyToClipboard text={text}
                                            onCopy={() => message.success("Скопировано")}>
                                            <Button>Скопировать</Button>
                                        </CopyToClipboard>
                                    </div>

                                    <div style={{ maxHeight: "600px", overflow: "auto" }}>
                                        <pre>
                                            {text}
                                        </pre>
                                    </div>
                                </div>
                            )
                        },
                    }
                ]}
            />
            {(isAnyFederationAdministrator(user)) && <Action
                readonly={false}
                auth={auth}
                action={(values, unlock, close) => {
                    close();
                }}
                modal={{
                    title: 'Отчет - "Изменение рейтингов для VK"',
                    width: "700px"
                }}
                // okText="Построить отчет"
                mode={"func"}
                trigger={(click) => (
                    <div>
                        <Button type="link" onClick={click}>Отчет - "Изменение рейтингов для VK"</Button>
                    </div>
                )}
                steps={[
                    {
                        key: "request",
                        name: "Шаг 1",
                        form: ReportRatingVKForm,
                        action: (values, unlock, close) => {
                            let daterating = dayjs(values.daterating).format("YYYY-MM-DD")

                            POSTFormData(auth, `/api/report/ratingvk`, makeFormData({ ...values, daterating }),
                                ({ data }) => {
                                    close({ text: data });
                                },
                                (err) => errorCatch(err, () => unlock())
                            );
                        },
                    },
                    {
                        key: "view",
                        name: "Шаг 3",
                        noAntForm: true,
                        okText: "Закрыть",
                        form: (props) => {
                            let text = props?.data?.request?.text || ""
                            return (
                                <div>
                                    <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                                        <CopyToClipboard text={text}
                                            onCopy={() => message.success("Скопировано")}>
                                            <Button>Скопировать</Button>
                                        </CopyToClipboard>
                                    </div>

                                    <div style={{ maxHeight: "600px", overflow: "auto" }}>
                                        <pre>
                                            {text}
                                        </pre>
                                    </div>
                                </div>
                            )
                        },
                    }
                ]}
            />}
            {(isAnyFederationAdministrator(user)) && <Action
                auth={auth}
                action={(values, unlock, close) => {
                    var datestart = dayjs(values.datestart).format("YYYY-MM-DD")
                    var dateend = dayjs(values.dateend).format("YYYY-MM-DD")
                    auth.fetchFile(`/api/report/sudeystvo-za-period?datestart=${datestart}&dateend=${dateend}`)
                        .then(async (res) => {
                            close();
                        });
                }}
                modal={{
                    title: "Судейство"
                }}
                okText="Построить отчет"
                mode={"func"}
                form={(props) => {
                    const { auth, form, submit } = props;
                    return (
                        <Form
                            form={form}
                            onFinish={submit}
                            labelAlign={"left"}
                            layout={"vertical"}
                        >
                            <Form.Item
                                label={"Дата начала"}
                                name={"datestart"}
                                rules={[{ required: true, message: 'Пожалуйста, укажите дату начала!' }]}
                            >
                                <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                            </Form.Item>

                            <Form.Item
                                label={"Дата окончания"}
                                name={"dateend"}
                                rules={[{ required: true, message: 'Пожалуйста, укажите дату окончания!' }]}
                            >
                                <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                            </Form.Item>
                        </Form>
                    )
                }}
                trigger={(click) => (
                    <div>
                        <Button type="link" onClick={click}>Судейство</Button>
                    </div>
                )}
            />}
            {(isAnyFederationAdministrator(user)) && <Action
                auth={auth}
                action={(values, unlock, close) => {
                    var datestart = dayjs(values.datestart).format("YYYY-MM-DD")
                    var dateend = dayjs(values.dateend).format("YYYY-MM-DD")
                    auth.fetchFile(`/api/report/prodazhi-za-period?datestart=${datestart}&dateend=${dateend}`)
                        .then(async (res) => {
                            close();
                        });
                }}
                modal={{
                    title: "Отчет по продажам за период"
                }}
                okText="Построить отчет"
                mode={"func"}
                form={(props) => {
                    const { auth, form, submit } = props;
                    return (
                        <Form
                            form={form}
                            onFinish={submit}
                            labelAlign={"left"}
                            layout={"vertical"}
                        >
                            <Form.Item
                                label={"Дата начала"}
                                name={"datestart"}
                                rules={[{ required: true, message: 'Пожалуйста, укажите дату начала!' }]}
                            >
                                <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                            </Form.Item>

                            <Form.Item
                                label={"Дата окончания"}
                                name={"dateend"}
                                rules={[{ required: true, message: 'Пожалуйста, укажите дату окончания!' }]}
                            >
                                <DatePicker style={{ width: "100%" }} suffixIcon={<></>} format="YYYY-MM-DD" locale={locale} />
                            </Form.Item>
                        </Form>
                    )
                }}
                trigger={(click) => (
                    <div>
                        <Button type="link" onClick={click}>Отчет по продажам за период</Button>
                    </div>
                )}
            />}
        </PageLayout>
    );
}
